import React from 'react';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import type { MenuItem } from '@wix/da-ds/pkg/Dropdown/MenuList';
import SaleBanner from '../../../../banners/SaleBanner';
import { useCurrentPromo } from '../../../../utils/hooks/useCurrentPromo';

export function useSaleBannerItem(): (MenuItem & { key: string }) | false {
  const currentPromo = useCurrentPromo('self');
  return (
    !!currentPromo && {
      key: 'sale-banner',
      label: (
        <SaleBanner
          isNarrow
          endDate={currentPromo.endDate}
          discountValuePercent={currentPromo.discountValuePercent}
          referralType={ReferralType.PROMOTION_BANNER_USERMENU}
        />
      ),
    }
  );
}
